/**
 * Class description
 *
 * Created: 2019-07-30
 * @author jonas
 */
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";

export class TombOfAkhenatenTextStyles {

    public static WIN_COUNT_UP: BitmapTextStyleOptions = {
        font: {
            name: "NumbersWinCountUp",
            size: 200
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    static BONUS_GAME_MULTIPLIER: BitmapTextStyleOptions = {
        font: {
            name: "bonusGameMultiplierFont",
            size: 10
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    static BONUS_GAME_MULTIPLIER_GLOW: BitmapTextStyleOptions = {
        font: {
            name: "bonusGameMultiplierFontGlow",
            size: 10
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    static BONUS_GAME_BIG_MULTIPLIER: BitmapTextStyleOptions = {
        font: {
            name: "centerBigMultiplier",
            size: 40
        },
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    static TOA_TEXT_FONT: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Anirb",
        fontSize: 50,
        fontWeight: FontWeight.NORMAL,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFF59F",
        lineJoin: "round",
        stroke: "#783f02",
        strokeThickness: 8,
        padding: 10
    });

    static GAME_INTRO_TEXT_FONT: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Anirb",
        fontSize: 25,
        fontWeight: FontWeight.NORMAL,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFF59F",
        lineJoin: "round",
        stroke: "#783f02",
        strokeThickness: 8,
        padding: 10
    });

    //358
    static FS_OUTRO_FONT: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Anirb",
        fontSize: 25,
        fontWeight: FontWeight.NORMAL,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
        fill: "#FFF59F",
        lineJoin: "round",
        stroke: "#783f02",
        strokeThickness: 4,
        padding: 5
    });

    static TOA_NUM_FONT: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Anirb",
        fontSize: 100,
        fontWeight: FontWeight.NORMAL,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFF59F",
        lineJoin: "round",
        stroke: "#783f02",
        strokeThickness: 8,
        padding: 10
    });

    public static AWARDED_SPIN: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Anirb",
        fontSize: 72,
        fontWeight: FontWeight.NORMAL,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFF59F",
        lineJoin: "round",
        stroke: "#783f02",
        strokeThickness: 8,
        padding: 10
    });

    public static AWARDED_SPIN_SMALL: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Anirb",
        fontSize: 84,
        fontWeight: FontWeight.NORMAL,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFF59F",
        lineJoin: "round",
        stroke: "#783f02",
        strokeThickness: 8,
        padding: 10
    });
}